module.exports = __webpack_public_path__ + "img/vulcans-sub-features-2.8dacbfc.jpg";